import type { TSerializedWidget } from 'src/entities/workspace/types';
import type {
  HeatmapWidgetEntity,
  THeatmapSerializedInternalState,
} from 'src/pages/dashboard/features/heatmap-widget/HeatmapWidget.entity';

export function serializeHeatmapWidget(widget: HeatmapWidgetEntity): TSerializedWidget {
  const internalState: THeatmapSerializedInternalState = {
    wellId: widget.wellId,
    stateParams: widget.stateParams,
  };

  return {
    wellId: widget.wellId,
    uuid: widget.uuid,
    type: widget.type,
    groupId: widget.groupId,
    size: {
      w: widget.size.w,
      h: widget.size.h,
    },
    position: {
      x: widget.position.x,
      y: widget.position.y,
    },
    isFullscreen: widget.isFullscreen,
    internalState,
  };
}
